export function appendZIndexIfNeed(className, zIndexClassName) {
    return className ? (!/-z-/.test(className) ? `${className} ${zIndexClassName}` : className) : zIndexClassName;
}
//# sourceMappingURL=dropdown.logic.js.map